import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.notifications.index'),
        name: 'notifications.index',
        component: () =>
            import(
                /* webpackChunkName: "notifications" */ '@/views/notifications/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.notifications.breadcrumb.index'),
                    to: { name: 'notifications.index' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.notifications.create'),
        name: 'notifications.create',
        component: () =>
            import(
                /* webpackChunkName: "notifications" */ '@/views/notifications/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.notifications.breadcrumb.index'),
                    to: { name: 'notifications.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.notifications.breadcrumb.create'),
                    to: null,
                    disable: true,
                },
            ],
        },
        props: true,
    },
    {
        path: '/' + i18n.t('routes.notifications.edit') + '/:id',
        name: 'notifications.edit',
        component: () =>
            import(
                /* webpackChunkName: "notifications" */ '@/views/notifications/Edit.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.notifications.breadcrumb.index'),
                    to: { name: 'notifications.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.notifications.breadcrumb.edit'),
                    to: null,
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
